import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import {Provider} from 'react-redux';
import {createBrowserHistory as createHistory} from 'history';
import {routerReducer, routerMiddleware} from 'react-router-redux';
import thunk from 'redux-thunk';
import {reducer as notifReducer} from 'redux-notifications';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'redux-notifications/lib/styles.css';
import 'react-widgets/dist/css/react-widgets.css';
import './resources/css/global.css';
import './resources/css/bootstrapDropdownOverride.css';
import './resources/css/bootstrapModalOverride.css';
import './resources/css/reactWidgetsDropdownOverride.css';

import reducers from './reducers';
import actions from './actions';
import {responseInterceptorMiddleware} from './utils/request';
import Skeleton from './containers/skeleton';

(function () {
    const history = createHistory({
        basename: process.env.BASE_HREF,
        getUserConfirmation(message, callback) {
            store.dispatch(actions.boConfirm(message, callback));
        }
    });
    const store = createStore(
        combineReducers({
            ...reducers,
            router: routerReducer,
            notifs: notifReducer
        }),
        applyMiddleware(responseInterceptorMiddleware, routerMiddleware(history), thunk)
    );
    ReactDOM.render(
        <Provider store={store}>
            <Skeleton history={history}/>
        </Provider>,
        document.getElementById('root')
    );
})();


// WEBPACK FOOTER //
// ./src/app/index.js